import 'css-chunk:src/feature/checks/ChecksFloorPlan.module.scss';export default {
  "dropdown": "ChecksFloorPlan_dropdown",
  "editorRoot": "ChecksFloorPlan_editorRoot",
  "editorHeader": "ChecksFloorPlan_editorHeader",
  "grid": "ChecksFloorPlan_grid",
  "viewer": "ChecksFloorPlan_viewer",
  "noEdit": "ChecksFloorPlan_noEdit"
};